import { useFormContext } from 'react-hook-form'
import { twMerge } from 'tailwind-merge'

type Props = {
  name: string
  label?: string
  children?: string
  hideError?: boolean
  group?: string
  disabled?: boolean
  indent?: boolean
}

const CheckboxInput = ({
  name,
  label,
  children,
  hideError = false,
  group,
  disabled,
  indent = false,
  ...rest
}: Props) => {
  const { register, getFieldState, formState } = useFormContext()
  const { error } = getFieldState(name, formState)

  return (
    <div className={`block ${indent ? 'ml-6' : ''}`}>
      <div className="mt-2" data-gt-name="componentevent">
        <div>
          <label
            className={`inline-flex items-baseline cursor-pointer ${
              disabled ? 'opacity-60 cursor-default' : ''
            }`}
            htmlFor={group || name}
          >
            <input
              id={group || name}
              name={name}
              className={twMerge(
                `rounded border-base text-base cursor-pointerfocus:border-blue focus:ring focus:ring-offset-0 focus:ring-blue group-checked:border-base`,
                error && 'border-red',
                disabled && 'cursor-default',
              )}
              type="checkbox"
              disabled={disabled}
              aria-invalid={error ? 'true' : 'false'}
              data-gt-action="checkbox-input-interaction"
              data-gt-label={name}
              {...register(name)}
              {...rest}
            />
            <span className="ml-2 normal-case">{label || children}</span>
          </label>
          {error && !hideError && (
            <p className="text-red text-tiny mt-1" role="alert">
              {error.message}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default CheckboxInput
